import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP6ChurnedNew202506: FaireAdPerformancePeriodEntity = {
  token: "perf_p6_churned_new_202506",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2025-06-01",
  endDate: "2025-06-30",
  impressions: 39579,
  clicks: 818,
  adsSpendDollars: 1302,
  budgetDollars: 1800,
  salesDollars: 5633,
  bestEstimateRoas: 4.33,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.72,
  newCustomersAcquired: 12,
  dataAvailableAtDate: "2025-07-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
